'use client';
import React from 'react';
import { gray1200 } from '@mentimeter/ragnar-colors';
import { Action } from 'src/ui/actions/Action';
import { Section, Wide } from '@mentimeter/content-ui/Layout';
import { H1, Meta, Subheading } from '@mentimeter/content-ui/Typography';
import { Box } from '@mentimeter/ragnar-ui/box';
import Track from 'src/components/Track';
import type { CompanyRoleGroup } from './executiveRoles';

interface HeroProps {
  title: string;
  subtitle: string;
  cta: string;
  cta_description?: string;
  roleGroup: CompanyRoleGroup;
  isAuthenticated?: boolean;
}

const Hero = ({
  title,
  subtitle,
  cta,
  cta_description,
  isAuthenticated,
  roleGroup,
}: HeroProps) => {
  let buttonData = {};

  if (isAuthenticated) {
    const href =
      roleGroup === 'executives'
        ? `/enterprise?referral=executives&cta=${cta}`
        : '/app';
    buttonData = { href, children: cta };
  } else {
    buttonData = {
      href: '/auth/signup?referral=homepage',
      children: cta,
      alignItems: 'flex-start',
    };
  }

  return (
    <Section px={['space8', null, null, 6]} py="space0" pt="space16">
      <Wide justifyContent="center" alignItems="center">
        {roleGroup === 'executives' ? (
          <Track event="Viewed CTA executives" />
        ) : null}
        <H1
          fontSize={['200', 7, '70px']}
          fontWeight="regular"
          width="650px"
          textAlign="center"
          mb="space4"
        >
          {title}
        </H1>
        <Subheading
          fontSize={['100', '125', '21px']}
          width={['270px', '540px']}
          textAlign="center"
          fontWeight="regular"
          color={gray1200}
          mb="space4"
        >
          {subtitle}
        </Subheading>

        <Box alignItems="center">
          <Action {...buttonData} mb="space4" variant="primary" size="large" />
          {!isAuthenticated && cta_description && (
            <Meta>{cta_description}</Meta>
          )}
        </Box>
      </Wide>
    </Section>
  );
};

export default Hero;
